import { useEffect, useState } from 'react'
import axios from 'axios'

export function Watchlist() {
  const [watchlist, setWatchlist] = useState<any[]>([])
  const [newTicker, setNewTicker] = useState('')
  const [loading, setLoading] = useState(true)
  
  useEffect(() => {
    fetchWatchlist()
  }, [])
  
  const fetchWatchlist = async () => {
    try {
      const response = await axios.get('https://api.finapp.aerotage.com/api/watchlist')
      setWatchlist(response.data.watchlist || [])
    } catch (error) {
      console.error('Failed to fetch watchlist:', error)
    } finally {
      setLoading(false)
    }
  }
  
  const addTicker = async () => {
    if (!newTicker) return
    
    try {
      await axios.post('https://api.finapp.aerotage.com/api/watchlist', {
        ticker: newTicker.toUpperCase(),
        notes: ''
      })
      setNewTicker('')
      fetchWatchlist()
    } catch (error) {
      console.error('Failed to add to watchlist:', error)
    }
  }
  
  const removeTicker = async (ticker: string) => {
    try {
      await axios.delete(`https://api.finapp.aerotage.com/api/watchlist/${ticker}`)
      fetchWatchlist()
    } catch (error) {
      console.error('Failed to remove from watchlist:', error)
    }
  }
  
  return (
    <div className="space-y-6">
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-2xl font-bold mb-4">Watchlist</h2>
        
        {loading ? (
          <div className="text-center py-12">Loading watchlist...</div>
        ) : (
          <>
            <div className="flex space-x-4 mb-6">
              <input
                type="text"
                value={newTicker}
                onChange={(e) => setNewTicker(e.target.value.toUpperCase())}
                placeholder="Add ticker (e.g., AAPL)"
                className="flex-1 px-4 py-2 border border-gray-300 rounded-md"
                onKeyPress={(e) => e.key === 'Enter' && addTicker()}
              />
              <button
                onClick={addTicker}
                className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Add
              </button>
            </div>
            
            <div className="space-y-2">
              {watchlist.map((item) => (
                <div key={item.ticker} className="flex justify-between items-center p-4 border rounded-lg hover:bg-gray-50">
                  <div>
                    <span className="font-bold text-lg">{item.ticker}</span>
                    {item.notes && <span className="ml-3 text-gray-600">{item.notes}</span>}
                  </div>
                  <button
                    onClick={() => removeTicker(item.ticker)}
                    className="text-red-600 hover:text-red-800"
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

